import React from "react";
import { withRouter } from "react-router";
import { Redirect } from 'react-router-dom'
import { authActions } from "../actions";
import { connect } from "react-redux";
import Redirecting from "../components/Redirecting";
import { authType } from '../utils/auth'

const Auth = props => {
  const { match, fetchAuth, clearAuth } = props;

  if (match.path === "/login/:token") {
    fetchAuth(match.params.token);
  } else if (match.path === "/sair") {
    clearAuth();
  }

  if (authType('adfs')) {
    return <Redirecting />;
  } else {
    return <Redirect to="/entrar" />;
  }
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
  return {
    fetchAuth: token => {
      dispatch(authActions.fetchAuth(token));
    },
    clearAuth: () => {
      dispatch(authActions.clearAuth());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Auth));



// WEBPACK FOOTER //
// ./src/components/Auth.js